import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
	elementTypes: {},
	newElementType: {},
	newElement: {},
	activeAtom: {},
	activeElement: {},
	elements: {},
	spaces: {},
	treeviewOpen: [],
	currentParent: 0,
	currentSpace: false,
	currentSpaceElements: [],
	atoms: [{
		id: 2,
		name: 'Textfeld',
		component: 'inputtext',
		isCurrent: false,
		defaults: {
			value: {
				type: 'text',
				label: 'Default Value',
				description: 'Can be prefilled with a standard value.',
				value: ""
			},
			name: {
				type: 'text',
				label: 'Name',
				description: 'Identifier of this field. Useful for reports.',
				value: ""
			},
			label: {
				type: 'text',
				label: 'Label',
				description: 'The label of the text field. To remove label just leave empty.',
				value: "Text Field Label"
			},
			iseditable: {
				type: 'checkbox',
				label: 'enabled',
				headline: 'Quick edit',
				description: 'Should element be editable directly in overviews',
				value: true
			},
			floatingLabel: {
				type: 'checkbox',
				label: 'enabled',
				headline: 'Floating Label',
				description: 'Show Input with floating label',
				value: false
			},
			placeholder: {
				type: 'text',
				label: 'Placeholder',
				description: '',
				value: 'type here...'
			},
			width: {
				type: 'range',
				label: 'Width of column',
				description: 'Width of column in input form',
				value: 12,
				min: 1,
				max: 12,
				step: 1
			},
			listview: {
				type: 'text',
				label: 'Text for list preview',
				description: 'Serves as placeholder text for the list preview kit',
				value: "Text Value"
			}
		}
	}, 
	{
		id: 1,
		name: 'Single Checkbox',
		component: 'checkbox',
		isCurrent: false,
		defaults: {
			value: {
				type: 'checkbox',
				label: 'Standard state',
				description: 'Initially not checked.',
				value: false
			},
			name: {
				type: 'text',
				label: 'Name',
				description: 'Identifier of this field. Useful for reports.',
				value: ""
			},
			label: {
				type: 'text',
				label: 'Label',
				description: 'The label of the text field. To remove label just leave empty.',
				value: 'Label'
			},
			iseditable: {
				type: 'checkbox',
				label: 'enabled',
				headline: 'Quick edit',
				description: 'Should element be editable directly in overviews',
				value: true
			},
			width: {
				type: 'range',
				label: 'Width of column',
				description: 'Width of column in input form',
				value: 12,
				min: 1,
				max: 12,
				step: 1
			},
			listview: {
				type: 'text',
				label: 'Text for list preview',
				description: 'Serves as placeholder text for the list preview kit',
				value: "Text Value"
			}
		}
	},
	{
		id: 2,
		name: 'ToDo',
		component: 'todo',
		isCurrent: false,
		defaults: {
			value: {
				type: 'hidden',
				value: {
					state: false,
					text: ""
				}
			},
			name: {
				type: 'text',
				label: 'Name',
				description: 'Identifier of this field. Useful for reports.',
				value: ""
			},
			iseditable: {
				type: 'checkbox',
				label: 'enabled',
				headline: 'Quick edit',
				description: 'Should element be editable directly in overviews',
				value: true
			},
			placeholder: {
				type: 'text',
				label: 'Placeholder',
				description: '',
				value: 'type here...'
			},
			width: {
				type: 'range',
				label: 'Width of column',
				description: 'Width of column in input form',
				value: 12,
				min: 1,
				max: 12,
				step: 1
			}
		}
	}]
}

import * as mutations from './vuex/mutations'

import * as actions from './vuex/actions'

// getters are functions
const getters = {

	spaceChildren: (state, getters) => (id) => {
		const spaceElements = _(state.elements.data)
		    .keyBy('id')
		    .at(state.currentSpace.children)
		    .filter()
		    .value();
		return spaceElements;
	},
	allElementsIDs: (state,getter) => {
		return _.map(state.elements.data,'id')
	},
	elementChildren: (state, getters, children) => {
		const elementChildren = _(state.elements.data)
		    .keyBy('id')
		    .at(children)
		    .filter()
		    .value();
		return elementChildren;
	},
	elementDefaults: (state, getters) => (ref, parameter) => {
		let matchedElType = _.find(state.elementTypes.data, {
			id: ref
		});
		//console.log("matchedElTypeModel",matchedElType) 
		if(parameter){
			if (matchedElType) {
				return matchedElType[parameter];
			} else {
				return "";
			}
		}
		else {
			if (matchedElType) {
				return matchedElType;
			} else {
				return "";
			}
		}
		
	},		
	atomDefaults: (state, getters) => (ref, areaindex, atomindex, param) => {
		let matchedElType = _.find(state.elementTypes.data, {
			id: ref
		});
		if (matchedElType) {
			if(param){
				return matchedElType.inputform.areas[areaindex]['atoms'][atomindex]['defaults'][param]['value'];
			}
			else {
				return matchedElType.inputform.areas[areaindex]['atoms'][atomindex]['defaults'];
			}
		} else {
			return "";
		}
	}
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js